import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { siteRecaptchaKey } from 'utils/env'
import ECAddressComponent from '../ECAddressComponent'

const ECAddressWrapperComponent = ({ flowName, setShowShippingLayout }: any) => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={siteRecaptchaKey}>
            <ECAddressComponent
                flowName={flowName}
                setShowShippingLayout={setShowShippingLayout}
            />
        </GoogleReCaptchaProvider>
    )
}

export default ECAddressWrapperComponent